import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { SitePlanItem } from '../types';
import { useIsMobile } from '../hooks/mobile-hooks';
import SitePlanCardThumbnail from './SitePlanCardThumbnail';

interface SitePlanCardProps {
  plan: SitePlanItem;
  onClick?: (plan: SitePlanItem) => void;
}

export const SitePlanCard: React.FC<SitePlanCardProps> = ({ plan, onClick }) => {
  const isMobile = useIsMobile();
  const meta = [plan.district, plan.topYear ? `TOP: ${plan.topYear}` : null, plan.region]
    .filter(Boolean)
    .join(' • ');

  return (
    <Card
      onClick={() => onClick?.(plan)}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        transition: isMobile ? 'all 150ms ease' : 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': onClick
          ? {
              transform: isMobile ? 'none' : 'translateY(-8px)',
              boxShadow: '0 8px 24px rgba(var(--color-shadow-rgb), 0.3)',
            }
          : undefined,
      }}
    >
      <SitePlanCardThumbnail
        projectName={plan.projectName}
        imageUrl={plan.imageUrl}
        mapLatitude={plan.mapLatitude}
        mapLongitude={plan.mapLongitude}
      />
      <CardContent>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, mb: 1.5, color: 'var(--color-text-strong)' }}
        >
          {plan.projectName}
        </Typography>
        {meta && (
          <Typography
            variant="body2"
            sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', mb: 0.5 }}
          >
            {meta}
          </Typography>
        )}
        {plan.street && (
          <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
            {plan.street}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default SitePlanCard;
